export class LaunchDarkly {
  public static TEAM_SPACE_ENABLED = 'team-space-manager-enabled-v1-061220'; // DO NOT REMOVE - https://degreedjira.atlassian.net/wiki/x/7wDaZQE
  public static LEARNING_INSIGHTS = 'skill-coach-learning-insights-101920'; // DO NOT REMOVE - https://degreedjira.atlassian.net/wiki/x/7wDaZQE
}
